import React, { useState, useRef } from 'react';
import { goToLink } from './../utils/Functions';
import Button from './bper-button';
import parseHTML from "html-react-parser";

const Marker = ({ children }) => children;

export default function SubsidiaryItem({ translations, subsidiary, apiKey }) {
    const [place, setPlace] = useState(JSON.parse(localStorage.getItem("place-search")));

    const capitalize = (string) => {
        const words = string.split(/([ \-'/0-9]+)/);


        let capitalizedWords = words.map(word => {
            if (!/^[ \-'/0-9]+$/.test(word)) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }
            return word;
        });

        return capitalizedWords.join('');
    }

    const linkIndicazioniStradali = place && subsidiary
        ? 'https://www.google.com/maps/dir/' +
        place.lat +
        ',' +
        place.lng +
        '/' +
        subsidiary.latitude +
        ',' +
        subsidiary.longitude
        : !place && subsidiary
            ? 'https://www.google.com/maps/dir//' +
            subsidiary.latitude +
            ',' +
            subsidiary.longitude
            : undefined;

    const stopPropagation = (e) => {
        e && e.stopPropagation();
        e && e.nativeEvent.stopImmediatePropagation();
    }

    const bankCode = subsidiary.subsdiaryType !== 'CP' ? 'bankCode-0'+`${subsidiary.bankCode}` : 'bankCode-cp';

    subsidiary && console.log(subsidiary)

    const currentDay = new Date().getDay();
    const currentTime = new Date();
    const currentDate = new Date().toISOString().split('T')[0]; //es.2020-11-25
    const time_mattino =
        currentDay === 1
            ? subsidiary.timetables && subsidiary.timetables.openMondayMorning
            : currentDay === 2
                ? subsidiary.timetables && subsidiary.timetables.openTuesdayMorning
                : currentDay === 3
                    ? subsidiary.timetables && subsidiary.timetables.openWednesdayMorning
                    : currentDay === 4
                        ? subsidiary.timetables && subsidiary.timetables.openThursdayMorning
                        : currentDay === 5
                            ? subsidiary.timetables && subsidiary.timetables.openFridayMorning
                            : currentDay === 6
                                ? subsidiary.timetables && subsidiary.timetables.openSaturdayMorning
                                : subsidiary.timetables && subsidiary.timetables.openSundayMorning; //currentDay=7

    const time_pomeriggio =
        currentDay === 1
            ? subsidiary.timetables && subsidiary.timetables.openMondayAfternoon
            : currentDay === 2
                ? subsidiary.timetables && subsidiary.timetables.openTuesdayAfternoon
                : currentDay === 3
                    ? subsidiary.timetables && subsidiary.timetables.openWednesdayAfternoon
                    : currentDay === 4
                        ? subsidiary.timetables && subsidiary.timetables.openThursdayAfternoon
                        : currentDay === 5
                            ? subsidiary.timetables && subsidiary.timetables.openFridayAfternoon
                            : currentDay === 6
                                ? subsidiary.timetables && subsidiary.timetables.openSaturdayAfternoon
                                : subsidiary.timetables && subsidiary.timetables.openSundayAfternoon; //currentDay=7

    const time_start_mattino =
        time_mattino && time_mattino.toLowerCase() !== 'chiuso'
            ? new Date(
                currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                time_mattino.split(' ')[0].split(".")[0],time_mattino.split(' ')[0].split(".")[1]
            )
            : undefined;

    const time_end_mattino =
        time_mattino && time_mattino.toLowerCase() !== 'chiuso'
            ? new Date(
                currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                time_mattino.split(' ')[1].split(".")[0],time_mattino.split(' ')[1].split(".")[1]
            )
            : undefined;

    const time_start_pomeriggio =
        time_pomeriggio && time_pomeriggio.toLowerCase() !== 'chiuso'
            ? new Date(
                currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                time_pomeriggio.split(' ')[0].split(".")[0],time_pomeriggio.split(' ')[0].split(".")[1]
            )
            : undefined;

    const time_end_pomeriggio =
        time_pomeriggio && time_pomeriggio.toLowerCase() !== 'chiuso'
            ? new Date(
                currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                time_pomeriggio.split(' ')[1].split(".")[0],time_pomeriggio.split(' ')[1].split(".")[1]
            )
            : undefined;

    let stringOpenTime = '';
    if (time_start_mattino && time_start_pomeriggio) {
        if (currentTime < time_start_mattino) {
            stringOpenTime =
                translations.NowCloseOpenAt + (time_mattino && time_mattino.split(' ')[0]);
        } else {
            if (currentTime < time_end_mattino) {
                stringOpenTime =
                    translations.OpenCloseAt + (time_mattino && time_mattino.split(' ')[1]);

            } else {
                if (currentTime < time_start_pomeriggio) {
                    stringOpenTime =
                        translations.NowCloseOpenAt + (time_pomeriggio && time_pomeriggio.split(' ')[0]);
                } else {
                    if (currentTime < time_end_pomeriggio) {
                        stringOpenTime =
                            translations.OpenCloseAt + (time_pomeriggio && time_pomeriggio.split(' ')[1]);
                    } else {
                        stringOpenTime = "<b>" + translations.NowClose + "</b>";
                    }
                }
            }
        }
    }

    const sameLunediVenerdi =
        subsidiary.timetables && (subsidiary.timetables.openMondayMorning === subsidiary.timetables.openTuesdayMorning &&
            subsidiary.timetables.openMondayMorning === subsidiary.timetables.openWednesdayMorning &&
            subsidiary.timetables.openMondayMorning === subsidiary.timetables.openThursdayMorning &&
            subsidiary.timetables.openMondayMorning === subsidiary.timetables.openFridayMorning &&
            subsidiary.timetables.openMondayAfternoon === subsidiary.timetables.openTuesdayAfternoon &&
            subsidiary.timetables.openMondayAfternoon === subsidiary.timetables.openWednesdayAfternoon &&
            subsidiary.timetables.openMondayAfternoon === subsidiary.timetables.openThursdayAfternoon &&
            subsidiary.timetables.openMondayAfternoon === subsidiary.timetables.openFridayAfternoon);


    const sameSabatoDomenicaChiuso =
        subsidiary.timetables && (subsidiary.timetables.openSaturdayMorning.toLowerCase() === 'chiuso' &&
            subsidiary.timetables.openSundayMorning.toLowerCase() === 'chiuso' &&
            subsidiary.timetables.openSaturdayAfternoon.toLowerCase() === 'chiuso' &&
            subsidiary.timetables.openSundayAfternoon.toLowerCase() === 'chiuso');

    return (
        <div className="subsidiary-item | light-neutral-10">
            {subsidiary &&
                    <div className="text-content | display-flex flex-dir-col justify-content-between">
                        <div className="text-container">
                            {
                                bankCode === 'bankCode-05387' ? (
                                    <div className="subsidiary-info-card-type bankCode-05387 | font-body-m fw-400">{translations.bankName05387}</div>
                                ) : bankCode === 'bankCode-03084' ? (
                                    <div className="subsidiary-info-card-type bankCode-03084 | font-body-m fw-400">{translations.bankName03084}</div>
                                    ) : (
                                        <div className="subsidiary-info-card-type bankCode-cp | font-body-m fw-400">{translations.bankNameCP}</div>
                                    )
                            }
                            <h4 className="subsidiary-name | font-body-xl fw-400">{capitalize((subsidiary.subsidiaryDescription + '').toLowerCase())}</h4>
                            {subsidiary.address && (
                                <>
                                    <div className="store-info__address-container | display-flex">
                                        <div className="subsidiary-info-card-address-icon"/>
                                        <div className="store-info__address | font-body-l fw-400">
                                            {capitalize((subsidiary.address + '').toLowerCase())}, {subsidiary.zipCode}, {capitalize((subsidiary.cityDescription + '').toLowerCase())} <span>{subsidiary.c_provincia}</span>
                                        </div>
                                    </div>
                                    {linkIndicazioniStradali &&
                                        <Button
                                            className="directions"
                                            variant="outlined"
                                            onClick={() =>
                                                goToLink(linkIndicazioniStradali, '_blank')
                                            }
                                        >
                                            {translations.Directions}
                                        </Button>
                                    }
                                </>
                            )}
                            <div className={"orari-contatti " + subsidiary.subsdiaryType}>

                                {(
                                    (subsidiary.subsdiaryType === "FILIALE" ) ||
                                    (subsidiary.subsdiaryType === "CP") ||
                                    (subsidiary.subsdiaryType === "CI")
                                ) && (
                                    <div className="row horizontal contacts" style={{fontWeight: 400}}>
                                        {subsidiary.contacts.phone && (
                                            <a
                                                href={'tel:' + subsidiary.contacts.phone}
                                                className="phone"
                                                style={{fontWeight: 400}}
                                            >
                                                {subsidiary.contacts.phone}
                                            </a>
                                        )}
                                        {subsidiary.contacts.fax && (
                                            <a href={'fax:' + subsidiary.contacts.fax} className="fax" style={{fontWeight: 400}}>
                                                {subsidiary.contacts.fax}
                                            </a>
                                        )}
                                    </div>
                                )}
                                {false && (
                                    <>
                                        {
                                            stringOpenTime && <div className="row string-open-time" >{parseHTML(stringOpenTime.toString())}</div>
                                        }
                                        {
                                            subsidiary.cashLight &&
                                            <div className="row">
                                                            <span className="small">
                                                                {subsidiary.cashLight}
                                                            </span>
                                            </div>
                                        }
                                    </>
                                )}
                                {(
                                    (subsidiary.subsdiaryType === "FILIALE" ) ||
                                    (subsidiary.subsdiaryType != "CP")
                                ) &&  subsidiary.timetables  && (
                                    <div className="row horizontal orari-wrapper">
                                        <div className="orari-content">
                                            {sameLunediVenerdi ? (
                                                <div className="subsidiary-item-orari-apertura bper-clock">
                                                    <div
                                                        className="subsidiary-item-giorni-label">{translations.MondayFriday}</div>
                                                    {
                                                        subsidiary.timetables && subsidiary.timetables.openMondayMorning.split(
                                                            ' '
                                                        )[0]
                                                    }
                                                    /
                                                    {
                                                        subsidiary.timetables && subsidiary.timetables.openMondayMorning.split(
                                                            ' '
                                                        )[1]
                                                    }
                                                    &nbsp;-&nbsp;
                                                    {
                                                        subsidiary.timetables && subsidiary.timetables.openMondayAfternoon.split(
                                                            ' '
                                                        )[0]
                                                    }
                                                    /
                                                    {
                                                        subsidiary.timetables && subsidiary.timetables.openMondayAfternoon.split(
                                                            ' '
                                                        )[1]
                                                    }
                                                </div>
                                            ) : (
                                                <>
                                                    <b style={{fontWeight: "700"}}>{translations.Monday}</b>
                                                    <ul>
                                                        {subsidiary.timetables && subsidiary.timetables.openMondayMorning.trim() ===
                                                        'chiuso' &&
                                                        subsidiary.timetables && subsidiary.timetables.openMondayAfternoon.trim() ===
                                                        'chiuso' ? (
                                                            <li>{translations.close}</li>
                                                        ) : (
                                                            <>
                                                                {subsidiary.timetables && subsidiary.timetables.openMondayMorning !==
                                                                'chiuso' ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openMondayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openMondayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                                {subsidiary.timetables && subsidiary.timetables.openMondayAfternoon !==
                                                                'chiuso' ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openMondayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openMondayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                            </>
                                                        )}
                                                    </ul>

                                                    <b style={{fontWeight: "700"}}>{translations.Tuesday}</b>
                                                    <ul>
                                                        {subsidiary.timetables && subsidiary.timetables.openTuesdayMorning.trim() ===
                                                        'chiuso' &&
                                                        subsidiary.timetables && subsidiary.timetables.openTuesdayAfternoon.trim() ===
                                                        'chiuso' ? (
                                                            <li>{translations.close}</li>
                                                        ) : (
                                                            <>
                                                                {subsidiary.timetables && subsidiary.timetables.openTuesdayMorning ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openTuesdayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openTuesdayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                                {subsidiary.timetables && subsidiary.timetables.openTuesdayAfternoon ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openTuesdayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openTuesdayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                            </>
                                                        )}
                                                    </ul>
                                                    <b style={{fontWeight: "700"}}>{translations.Wednesday}</b>
                                                    <ul>
                                                        {subsidiary.timetables && subsidiary.timetables.openWednesdayMorning.trim() ===
                                                        'chiuso' &&
                                                        subsidiary.timetables && subsidiary.timetables.openWednesdayAfternoon.trim() ===
                                                        'chiuso' ? (
                                                            <li>{translations.close}</li>
                                                        ) : (
                                                            <>
                                                                {subsidiary.timetables && subsidiary.timetables.openWednesdayMorning ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openWednesdayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openWednesdayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                                {subsidiary.timetables && subsidiary.timetables.openWednesdayAfternoon ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openWednesdayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openWednesdayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                            </>
                                                        )}
                                                    </ul>
                                                    <b style={{fontWeight: "700"}}>{translations.Thursday}</b>
                                                    <ul>
                                                        {subsidiary.timetables && subsidiary.timetables.openThursdayMorning.trim() ===
                                                        'chiuso' &&
                                                        subsidiary.timetables && subsidiary.timetables.openThursdayAfternoon.trim() ===
                                                        'chiuso' ? (
                                                            <li>{translations.close}</li>
                                                        ) : (
                                                            <>
                                                                {subsidiary.timetables && subsidiary.timetables.openThursdayMorning ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openThursdayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openThursdayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                                {subsidiary.timetables && subsidiary.timetables.openThursdayAfternoon ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openThursdayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openThursdayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                            </>
                                                        )}
                                                    </ul>
                                                    <b style={{fontWeight: "700"}}>{translations.Friday}</b>
                                                    <ul>
                                                        {subsidiary.timetables && subsidiary.timetables.openFridayMorning.trim() ===
                                                        'chiuso' &&
                                                        subsidiary.timetables && subsidiary.timetables.openFridayAfternoon.trim() ===
                                                        'chiuso' ? (
                                                            <li>{translations.close}</li>
                                                        ) : (
                                                            <>
                                                                {subsidiary.timetables && subsidiary.timetables.openFridayMorning ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openFridayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openFridayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                                {subsidiary.timetables && subsidiary.timetables.openFridayAfternoon ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openFridayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openFridayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                            </>
                                                        )}
                                                    </ul>
                                                </>
                                            )}
                                            {
                                                subsidiary.cashLight &&
                                                <div className="row subsidiary-item-open-info">
                                                    ({subsidiary.cashLight})
                                                </div>
                                            }
                                            {sameSabatoDomenicaChiuso ? (
                                                <>
                                                </>
                                            ) : (
                                                <div className="subsidiary-item-orari-apertura">
                                                    <div
                                                        className="subsidiary-item-giorni-label">{translations.Saturday}</div>
                                                    {subsidiary.timetables && subsidiary.timetables.openSaturdayMorning.trim() ===
                                                    'chiuso' &&
                                                    subsidiary.timetables && subsidiary.timetables.openSaturdayAfternoon.trim() ===
                                                    'chiuso' ? (
                                                        <li>{translations.close}</li>
                                                    ) : (
                                                        <>
                                                            {subsidiary.timetables && subsidiary.timetables.openSaturdayMorning ? (
                                                                <li>
                                                                    {
                                                                        subsidiary.timetables && subsidiary.timetables.openSaturdayMorning.split(
                                                                            ' '
                                                                        )[0]
                                                                    }
                                                                    -
                                                                    {
                                                                        subsidiary.timetables && subsidiary.timetables.openSaturdayMorning.split(
                                                                            ' '
                                                                        )[1]
                                                                    }
                                                                </li>
                                                            ) : (
                                                                <li>
                                                                    {translations.close}
                                                                </li>
                                                            )}
                                                            {subsidiary.timetables && subsidiary.timetables.openSaturdayAfternoon ? (
                                                                <li>
                                                                    {
                                                                        subsidiary.timetables && subsidiary.timetables.openSaturdayAfternoon.split(
                                                                            ' '
                                                                        )[0]
                                                                    }
                                                                    -
                                                                    {
                                                                        subsidiary.timetables && subsidiary.timetables.openSaturdayAfternoon.split(
                                                                            ' '
                                                                        )[1]
                                                                    }
                                                                </li>
                                                            ) : (
                                                                <li>
                                                                    {translations.close}
                                                                </li>
                                                            )}
                                                        </>
                                                    )}
                                                    <b style={{fontWeight: "700"}}>{translations.Sunday}</b>
                                                    <ul>
                                                        {subsidiary.timetables && subsidiary.timetables.openSundayMorning.trim() ===
                                                        'chiuso' &&
                                                        subsidiary.timetables && subsidiary.timetables.openSundayAfternoon.trim() ===
                                                        'chiuso' ? (
                                                            <li>{translations.close}</li>
                                                        ) : (
                                                            <>
                                                                {subsidiary.timetables && subsidiary.timetables.openSundayMorning ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openSundayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openSundayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                                {subsidiary.timetables && subsidiary.timetables.openSundayAfternoon ? (
                                                                    <li>
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openSundayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
                                                                        -
                                                                        {
                                                                            subsidiary.timetables && subsidiary.timetables.openSundayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                            </>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <Button
                            onClick={(e) => stopPropagation()}
                            href={bankCode === 'bankCode-05387' ? 'https://www.bper.it' + subsidiary.linkSubsidiaryCard
                                : (subsidiary.linkSubsidiaryCard ? subsidiary.linkSubsidiaryCard.replace("trova-filiali","trova-centri-private-e-filiali") : subsidiary.linkSubsidiaryCard)}
                            target="_blank"
                            className=""
                            variant="cta-ghost"
                            color=""
                        >
                            {translations.DiscoverDetail}
                        </Button>
                    </div>
            }
        </div >
    );
}
